var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainclass"},[(!_vm.matchMedia && _vm.filters.length)?_c('vch-product-filters',{attrs:{"filters":_vm.filters,"clear-btn-title":_vm.clearBtnTitle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }